module.exports = __webpack_public_path__ + "static/img/aboutUsa.0624e8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUsa.png
// module id = ZS5f
// module chunks = 1